<template>
  <div class="info-tooltip">
    <i class="material-icons md-18">info</i>
    <div class="tooltip smooth-shadow">
      <p>
        {{ text }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: String,
  },
};
</script>

<style lang="scss" scoped>
.info-tooltip {
  display: inline;
  position: relative;
  padding: auto 0;
  margin: 0 5px;

  i {
    opacity: 0.4;
    transition: 0.2s all ease-in-out;

    &:hover {
      opacity: 1;
      cursor: pointer;
    }

    &:hover ~ .tooltip {
      display: flex;
    }
  }

  .tooltip {
    display: none;
    position: absolute;
    width: 250px;
    background: var(--color-secondary);
    border-radius: 5px;
    padding: 10px;
    left: 25px;
    top: 7px;
    z-index: 90;

    p {
      all: revert;
      margin: 0;
      font-weight: normal;
      font-size: 14px;
      opacity: 0.7;
      color: var(--font-color);
    }
  }
}
</style>
